// extracted by mini-css-extract-plugin
export var stepActive = "_1n-3";
export var stepCompleted = "_1n-4";
export var stepConnectorLine = "_1n-b";
export var stepIndicatorCircle = "_1n-6";
export var stepIndicatorCircleCompleted = "_1n-7";
export var stepIndicatorCircleDefault = "_1n-8";
export var stepIndicatorTextCompleted = "_1n-9";
export var stepIndicatorTextDefault = "_1n-a";
export var stepPending = "_1n-5";
export var wizardContainer = "_1n-1";
export var wizardContent = "_1n-2";
export var wizardModal = "_1n-0";